import React, { useRef, useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Banner from "../Components/Mca-Sections/Banner";
import WhyChooseUs from "../Components/Mca-Sections/WhyChooseUs";
import JumpCareerCom from "../Components/Mca-Sections/JumpCareerCom";
import WhyStudentLove from "../Components/Mca-Sections/WhyStudentLove";
import TrustedCollages from "../Components/Mca-Sections/TrustedCollages";
import ExploreCourses from "../Components/Mca-Sections/ExploreCourses";
import Coureses from "../Components/Mca-Sections/Coureses";
import CounterComp from "../Components/Mca-Sections/CounterComp";
import Gallery from "../Components/Mca-Sections/Gallery";
import SummerProgram from "../Components/Mca-Sections/SummerProgram";
import BenefitSummer from "../Components/Mca-Sections/BenefitSummer";
import OurTrainer from "../Components/Sections/OurTrainer";
import Testimonial from "../Components/Mca-Sections/Testimonial";
import Certificates from "../Components/Mca-Sections/Certificates";
import LookOurWork from "../Components/Mca-Sections/LookOurWork";
import Footer from "../Components/Footer";
import FAQ from "../Components/Mca-Sections/FAQ";
import Popupform from "../Components/Mca-Sections/Popupform";
import EnrollForm from "../Components/Mca-Sections/EnrollForm";
import RegisterSection from "../Components/Mca-Sections/RegisterSection";
import { Helmet } from "react-helmet-async";
import { Element } from "react-scroll";

const McaInternship = () => {
  const CourseRef = useRef(null);
  const scrollCourses = () => {
    const navbarheight = 90;
    const courseOffset = CourseRef.current.offsetTop - navbarheight;
    // CourseRef.current.scrollIntoView({ behavior: 'smooth' });
    window.scrollTo({
      top: courseOffset,
      behavior: "smooth",
    });
  };

  const closeModel = () => {
    setShowPop(false);
  };
  const [showPop, setShowPop] = useState(false);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      // setShowPop(true);
      const paymentSec = document.getElementById("register-section");
      paymentSec.scrollIntoView({ block: "end" });
    }, [5000]);

    return () => clearTimeout(timeOut);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          6-Month Internship Program for MCA, BCA, & M.Sc. IT Students in Jaipur
        </title>
        <meta
          name="description"
          content="6-month internship by Upflairs Pvt. Ltd. for MCA/BCA/M.Sc. IT: Gain skills, live project experience, mentorship, certification & placement support."
        />
      </Helmet>
      {/* Banner */}
      <Banner scrollCourses={scrollCourses} />

      {/* Courses Section */}
      <Coureses ref={CourseRef} />

      {/* Why Choose Us */}
      {/* <WhyChooseUs /> */}

      {/* Jump Career */}
      <JumpCareerCom />

      {/* Why Student Love */}
      <WhyStudentLove />

      {/* Trusted Collages */}
      <TrustedCollages />

      {/* Explore Courses Section */}
      <ExploreCourses scrollCourses={scrollCourses} />

      {/* <RegisterSection/> */}
      <Element name="mca-register">
      <RegisterSection />
      </Element>

      {/* Counter Section */}
        <CounterComp />

      {/* Gallery Section */}
      <Gallery />

      {/* Summer Program */}
      <SummerProgram />

      {/* Benefits of Summer Program */}
      <BenefitSummer />

      {/* Our Trainer */}
      <OurTrainer />

      {/* Testimonial Section */}
      <Testimonial />

      {/* certicate  */}
      <Certificates />

      {/* FAQ */}
      <FAQ />

      {/* look our Work */}
      <LookOurWork />
      {/* <Popupform />
      {showPop && <EnrollForm closeModel={closeModel} />} */}
    </>
  );
};

export default McaInternship;
